__turbopack_context__.v({
  "closeButton": "HPBR8G_closeButton",
  "content": "HPBR8G_content",
  "contentGrid": "HPBR8G_contentGrid",
  "linkContainer": "HPBR8G_linkContainer",
  "linkItem": "HPBR8G_linkItem",
  "loadMoreContainer": "HPBR8G_loadMoreContainer",
  "open": "HPBR8G_open",
  "searchBox": "HPBR8G_searchBox",
  "searchBoxWrapper": "HPBR8G_searchBoxWrapper",
  "searchButton": "HPBR8G_searchButton",
  "searchResultContainer": "HPBR8G_searchResultContainer",
  "subtitle": "HPBR8G_subtitle",
  "title": "HPBR8G_title",
  "visuallyHidden": "HPBR8G_visuallyHidden",
});
